import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const Button = (props) => {
    const {
        children,
        dataTest = '',
        onClick = () => null,
        disabled,
        classNames = [],
        tabIndex = '-1',
    } = props;

    return (
        <button
            type="button"
            className={['custom-btn', ...classNames].join(' ')}
            onClick={onClick}
            disabled={disabled}
            tabIndex={tabIndex}
            data-test={dataTest}
        >
            {children}
        </button>
    );
};

Button.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    tabIndex: PropTypes.string,
    dataTest: PropTypes.string,
};

export default Button;
